import axiosHttp from "services/axiosHttp";

// Project Service Functions
export const projectService = {
  // Create project
  createProject: async (data) => {
    const response = await axiosHttp.post("/pmo/project", data);
    return response.data;
  },

  // Get project list with optional params
  getProjectList: async (params = {}) => {
    const response = await axiosHttp.get("/pmo/project", { params });
    return response.data;
  },

  // Get single project by ID
  getProject: async (id) => {
    const response = await axiosHttp.get(`/pmo/project/${id}`);
    return response.data;
  },

  // Update project
  updateProject: async (id, data) => {
    const response = await axiosHttp.put(`/pmo/project/${id}`, data);
    return response.data;
  },

  // Delete project
  deleteProject: async (id) => {
    const response = await axiosHttp.delete(`/pmo/project/${id}`);
    return response.data;
  },

  // Change project status
  changeProjectStatus: async (id, data) => {
    const response = await axiosHttp.put(`/pmo/project/${id}`, data);
    return response.data;
  },

  // Get project overview
  getProjectOverview: async (id) => {
    const response = await axiosHttp.get(`/pmo/project/${id}/overview`);
    return response.data;
  },

};
